import { useState, createContext } from 'react';

const CancelContext = createContext();

export const CancelProvider = ({children}) => {

  const [cancelData, setCancelData] = useState(false);

  return (
    <CancelContext.Provider value={{ cancelData, setCancelData }}>
      { children }
    </CancelContext.Provider>
  )

}

export default CancelContext;